// @flow
import React, { useContext, type ElementRef, type Node } from 'react';
import { b2cPagesService } from '@clubmed/utils';

import ResponsiveContext from 'Components/utils/responsive/responsiveContext';
import { ReactPageContext } from 'Context/pageContext';
import { type LanguagesProps } from 'Components/widgets/languages/Languages.jsx';

import { buildNavigationMenuItems } from './Navigation.mapper';
import { NavigationLarge } from './large/NavigationLarge.jsx';
import { StickyNavigationNarrow } from './narrow/NavigationNarrow.jsx';

type Props = {
  navigation: CMSNavigationBar,
  cmsAccount: CMSAccount,
  cmsMemberSpace: CMSMemberSpace,
  language: LanguagesProps,
  promoBannerRef: { current: ElementRef<Node> | null },
  userInfo?: UserInfo,
  id?: string,
};

export const Navigation = (props: Props) => {
  const { isDesktop } = useContext(ResponsiveContext);
  const { pageType } = useContext(ReactPageContext);

  const { navigation, userInfo, id, promoBannerRef, language, cmsAccount, cmsMemberSpace } = props;
  const {
    menus,
    menusMICE,
    contact,
    contactMICE,
    backButtonLabel,
    backButtonMainNavLabel,
    closeMainNavLabel,
    openMainNavLabel,
    backToB2CWebsiteLabel,
    backToB2CWebsiteLink,
    MICELogoRedirectionLink,
  } = navigation;

  const isMicePage = b2cPagesService.isMicePage(pageType);

  const navigationProps = {
    backToB2CWebsiteLabel,
    backToB2CWebsiteLink,
    cmsAccount,
    cmsMemberSpace,
    contact: isMicePage ? contactMICE : contact,
    id,
    isMicePage,
    items: buildNavigationMenuItems(isMicePage ? menusMICE : menus),
    language,
    promoBannerRef,
    userInfo,
    MICELogoRedirectionLink,
  };

  return isDesktop ? (
    <NavigationLarge {...navigationProps} />
  ) : (
    <StickyNavigationNarrow
      {...navigationProps}
      backButtonLabel={backButtonLabel}
      backButtonMainNavLabel={backButtonMainNavLabel}
      closeMainNavLabel={closeMainNavLabel}
      openMainNavLabel={openMainNavLabel}
    />
  );
};
